'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (type) {

    var supportedFiles = ['png', 'pdf', 'mp3', 'mp4', 'mov', 'jpg', 'html', 'psd', 'bmp', 'dwg', 'doc', 'xls', 'docx', 'ppt', 'xml', 'exe', 'avi', 'xlsx', 'ods', 'pps', 'txt', 'flv', 'mpg', '3gp', 'wav', 'zip', 'rar', 'gif'];

    var isSupportedFile = supportedFiles.find(function (el) {
        return el === type.toLowerCase();
    });

    if (isSupportedFile) {
        return 'document-file-' + isSupportedFile;
    } else {
        return "document";
    }
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/iconManager.js
// module id = 436
// module chunks = 0